import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  SafeHtmlPipe,
  SanitizerValueType,
} from '@pipes/safe-html/safe-html.pipe';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';

@Component({
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe, SvgIconComponent],
  templateUrl: './standard-confirmation-message-modal.component.html',
  styleUrls: ['./standard-confirmation-message-modal.component.scss', './standard-confirmation-message-modalb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardConfirmationMessageModalComponent {
  @Input() primaryBtnText: string;
  @Input() secondaryBtnText: string;
  @Input() messageText: string;
  @Input() titleText: string;
  @Input() imageUrl: string;
  @Input() variant: string = 'a';

  @Output() response = new EventEmitter<ModalAction>();

  readonly SanitizerValueType = SanitizerValueType;

  constructor(public bsModalRef: BsModalRef) {}

  onClick(action: ModalAction) {
    this.response.emit(action);
    this.bsModalRef.hide();
  }
}

export type ModalAction = 'primaryClick' | 'secondaryClick' | 'crossClick';


